export const securityGuardServer = {
  baseURL: 'https://security-guards.steady.darvis.dev',
}